import React from 'react';
import { Route, Switch } from 'react-router';

import PrivateRoute from '../../lib/privateRoute';
import CoachBounceRouteShim from '../../lib/CoachBounceRouteShim';
import ROUTES from '../../state/routes';

export default () => {
    const routes = mapRoutes(ROUTES);

    return (
        <Switch>
            {routes}
            <Route component={CoachBounceRouteShim} />
        </Switch>
    );
};

export const mapRoutes = viewRoutes => {
    let routes = [];
    Object.keys(viewRoutes).forEach(key => {
        const view = viewRoutes[key];

        if (view.path) {
            routes.push(createRoute(view));
        } else {
            routes = routes.concat(mapRoutes({ ...view }));
        }
    });
    return routes;
};

const createRoute = view => {
    if (view.isPublic) {
        return createPublicRoute(view);
    }

    return createPrivateRoute(view);
};

const createPublicRoute = view => {
    return (
        <Route path={view.path} key={view.path} component={view.component} />
    );
};

const createPrivateRoute = view => {
    return (
        <PrivateRoute
            exact
            path={view.path}
            key={view.path}
            component={view.component}
        />
    );
};
